import React from 'react';
import { Box, Heading } from '@wix/design-system';
import { ExactMatchHeadlineSkeleton } from './ExactMatchHeadlineSkeleton';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { InsightIntent } from '@wix/domains-serverless-interface';
import s from './ExactMatchHeadline.css';
export const ExactMatchHeadline = _ref => {
  var _data$insight;
  let {
    domain,
    dataHook = 'exact-match-headline'
  } = _ref;
  const {
    data,
    isLoading
  } = DomainsApiClient.hooks.useGetInsight({
    domain: domain,
    intent: {
      intent: InsightIntent.EXACT_MATCH
    }
  }, true, {
    staleTime: Infinity,
    cacheTime: Infinity
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(ExactMatchHeadlineSkeleton, {
      dataHook: `${dataHook}-skeleton`
    });
  }
  if (!(data != null && (_data$insight = data.insight) != null && _data$insight.description)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    paddingBottom: "SP3",
    align: "center",
    textAlign: "center",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2",
    className: s.headline
  }, data.insight.description));
};
//# sourceMappingURL=ExactMatchHeadline.js.map